import { render } from "./HospitalPrimaryInformation.vue?vue&type=template&id=7289872a"
import script from "./HospitalPrimaryInformation.vue?vue&type=script&lang=js"
export * from "./HospitalPrimaryInformation.vue?vue&type=script&lang=js"

import "./HospitalPrimaryInformation.vue?vue&type=style&index=0&id=7289872a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/HospitalPrimaryInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7289872a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7289872a', __exports__)) {
    console.log('reload')
    api.reload('7289872a', __exports__)
  }
  
  module.hot.accept("./HospitalPrimaryInformation.vue?vue&type=template&id=7289872a", () => {
    console.log('re-render')
    api.rerender('7289872a', render)
  })

}


export default __exports__